import { MultiSelect as PrimeMultiSelect, type MultiSelectProps } from 'primereact/multiselect'

/**
 * Paylaşılan çoklu-seçim (013 tasarım dili — Reuse Mandate). PrimeReact MultiSelect üzerine kurulu;
 * tam genişlik + varsayılan chip gösterimi + filtre. Görünüm global override'lardan gelir: seçim
 * **mavi** (`--focus`, DataTable seçimiyle aynı konvansiyon — accent kırmızı değil), panel/chip nötr
 * slate; odak input border/shadow paletiyle (`--focus` + `--focus-ring`). Tüm ekranlar bunu kullanır.
 */
export default function MultiSelect({ className, display = 'chip', filter = true, ...props }: Readonly<MultiSelectProps>) {
  return (
    <PrimeMultiSelect
      {...props}
      display={display}
      filter={filter}
      className={['ui-multiselect', className].filter(Boolean).join(' ')}
    />
  )
}
